(function () {
    document.addEventListener("DOMContentLoaded", () => {
        const menuToggle = document.getElementById('menuToggle');
        const menuCloseButton = document.getElementById('menuCloseButton');
        const siteNav = document.querySelector('.site-nav');
        const menuList = document.querySelector('.site-nav__list');
        const body = document.body;

        if (!menuToggle || !siteNav || !menuList || !menuCloseButton) {
            return;
        }



        let isMenuOpen = false;

        function openMenu() {
            isMenuOpen = true;
            body.classList.add('menu-open');
            siteNav.classList.add('site-nav--open');
            menuList.classList.remove('hidden');
            menuToggle.setAttribute('aria-expanded', 'true');
            body.style.overflow = 'hidden';
        }

        function closeMenu() {
            isMenuOpen = false;
            body.classList.remove('menu-open');
            siteNav.classList.remove('site-nav--open');
            menuToggle.setAttribute('aria-expanded', 'false');
            body.style.overflow = '';

            setTimeout(() => {
                menuList.classList.add('hidden');
            }, 400);
        }

        menuToggle.addEventListener('click', (e) => {
            e.preventDefault();
            if (!isMenuOpen) {
                openMenu();
            }
        });

        menuCloseButton.addEventListener('click', (e) => {
            e.preventDefault();
            if (isMenuOpen) {
                closeMenu();
            }
        });



        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && isMenuOpen) {
                closeMenu();
            }
        });

        const menuLinks = menuList.querySelectorAll('a');
        menuLinks.forEach(link => {
            link.addEventListener('click', () => {
                if (isMenuOpen) {
                    closeMenu();
                }
            });
        });

        window.addEventListener('resize', () => {
            if (isMenuOpen && window.innerWidth > 768) {
                closeMenu();
            }
        });

        // Background color change on hover
        const menuItems = document.querySelectorAll('.site-nav__item');

        // Determine the current active background class
        const currentMenuItem = document.querySelector('.site-nav__item.current-menu-item');
        let currentBgClass = '';

        if (currentMenuItem) {
            if (currentMenuItem.classList.contains('site-nav__item--spaces')) {
                currentBgClass = 'bg-spaces';
            } else if (currentMenuItem.classList.contains('site-nav__item--services')) {
                currentBgClass = 'bg-services';
            } else if (currentMenuItem.classList.contains('site-nav__item--gallery')) {
                currentBgClass = 'bg-gallery';
            } else if (currentMenuItem.classList.contains('site-nav__item--about')) {
                currentBgClass = 'bg-about';
            } else if (currentMenuItem.classList.contains('site-nav__item--press')) {
                currentBgClass = 'bg-press';
            }
        }

        // Set initial background color for current menu item
        if (currentBgClass) {
            siteNav.classList.add(currentBgClass);
        }

        menuItems.forEach(item => {
            let bgClass = '';

            // Determine background class based on item class
            if (item.classList.contains('site-nav__item--spaces')) {
                bgClass = 'bg-spaces';
            } else if (item.classList.contains('site-nav__item--services')) {
                bgClass = 'bg-services';
            } else if (item.classList.contains('site-nav__item--gallery')) {
                bgClass = 'bg-gallery';
            } else if (item.classList.contains('site-nav__item--about')) {
                bgClass = 'bg-about';
            } else if (item.classList.contains('site-nav__item--press')) {
                bgClass = 'bg-press';
            }

            if (bgClass) {
                item.addEventListener('mouseenter', () => {
                    // Remove current background class temporarily
                    if (currentBgClass) {
                        siteNav.classList.remove(currentBgClass);
                    }
                    // Add hover background class
                    siteNav.classList.add(bgClass);
                });

                item.addEventListener('mouseleave', () => {
                    // Remove hover background class
                    siteNav.classList.remove(bgClass);
                    // Restore current background class if it exists
                    if (currentBgClass) {
                        siteNav.classList.add(currentBgClass);
                    }
                });
            }
        });
    });
})();